import * as React from "react";
import {Business, CardTransaction} from "../../types/Types";
import TransactionRow from "./TransactionRow";
import {useState} from "react";
import DisplayListControl from "../list/DisplayListControl";

interface Props {
  transactions: Array<CardTransaction>,
  businessMap: Map<string, Business>,
  defaultDisplayList: boolean,
}

function TransactionList(props: Props) {
  const [displayList, setDisplayList] = useState<boolean>(props.defaultDisplayList);

  return (
      <div className={"mt-3"}>
        <div className={`list-title ${displayList ? "" : "mb-0"}`} onClick={() => setDisplayList(!displayList)}>
          <b>Transactions</b>
          <DisplayListControl displayList={displayList} count={props.transactions.length} />
        </div>
        {(props.transactions.length > 0 && displayList) && <div>
          {props.transactions.map((transaction, index) => (
              <div className={`${index == props.transactions.length-1 ? 'mb-0' : 'mb-2'}`}>
                <TransactionRow cardTransaction={transaction} business={props.businessMap.get(transaction.business)}/>
              </div>
          ))}
        </div>}
        {/*{(props.transactions.length === 0 && displayList) && <div className={"basic-box colour-secondary mt-2 mb-0"}>Nothing to display.</div>}*/}
      </div>
  )
}

export default TransactionList;